import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding-top: 120px;
  ::after {
    content: "";
    height: 60px;
    width: 1px;
    @media (min-width: 768px) {
      height: 0;
    }
  }
  .addButton {
    margin-top: 1rem;
  }
  @media (min-width: 768px) {
    padding-top: 150px;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  width: 90%;
  flex-wrap: wrap;
  justify-content: center;

  input {
    font-size: 18px;
    padding: 10px 20px 10px 5px;
    margin: 0.5rem;
    width: 300px;
    border: none;
    border-bottom: 1px solid var(--black-default);
  }
  button {
    margin: 0.5rem;
  }

  @media (max-width: 768px) {
    justify-content: start;
  }
`;
